import {useOutletContext} from "react-router-dom";

import {FormDirtyProvider} from "base/form/provider";
import {ViewPermitExtensionWidget} from ".";

const ViewPermitExtensionProcessSubPage = () => {
    const [entity] = useOutletContext();

    return entity ? (
        <FormDirtyProvider>
            <ViewPermitExtensionWidget entity={entity} process="application" />
        </FormDirtyProvider>
    ) : null;
};

export default ViewPermitExtensionProcessSubPage;
